import React from 'react'
import { RouteComponentProps } from 'wouter'

import { buildComponent } from '../../../components/factory'

import * as UI from '@mantine/core'
import * as Elements from '../../../components/elements'
import * as Components from './components'

export const ScreenConnectedGongs = buildComponent<
  RouteComponentProps<{ gong: string }>
>().withRender(({ props }) => (
  <React.Fragment>
    <Components.Title gong={props.params.gong} />

    <UI.Stack sx={{ maxWidth: 1280, margin: '2rem auto' }} spacing={32}>
      <UI.Card shadow="sm" pb={32} px={24}>
        <Components.SectionMain gong={props.params.gong} />
      </UI.Card>

      <UI.Card shadow="sm" pb={32} px={24}>
        <Components.SectionTrack gong={props.params.gong} />
      </UI.Card>

      <UI.Group position="center">
        <Elements.AudioDelete kind="gong" slug={props.params.gong} />
      </UI.Group>
    </UI.Stack>
  </React.Fragment>
))
